module.exports = __webpack_public_path__ + "media/images/premium/premium_ui_tw_02-450-86006f1ddba7c971217d168f8b6f5e78.png";